import { createStyles } from 'app/utils/css';
import React from 'react';
import { RED_G } from 'app/constants/Colors';
import { inputBaseStyles, inputHeight } from './styles';

type InputAttributes = React.InputHTMLAttributes<HTMLInputElement>;

export interface IProps extends Pick<InputAttributes, Exclude<keyof InputAttributes, 'onChange' | 'value'>> {
  onChange: (value: string) => void;
  value: string | null;
  error?: boolean;
  getRef?: (ref: HTMLInputElement) => void;
}

class Input extends React.Component<IProps> {
  public render() {
    const { value, error, style, getRef, ...rest } = this.props;

    return (
      <Styles attributes={{ error }}>{(css) =>
        <div className={css('container')} style={style}>
          <input
            type="text"
            {...rest}
            ref={getRef}
            className={css('input')}
            onChange={this.onChange}
            value={value || ''}
            style={style}
          />
        </div>
      }</Styles>
    );
  }

  private onChange = (event: React.ChangeEvent<HTMLInputElement>) => (
    this.props.onChange(event.target.value)
  );
}

const Styles = createStyles({
  container: {
    display: 'flex',
    flexGrow: 1,
  },
  input: ({ error }) => [
    {
      ...inputBaseStyles,
      height: inputHeight,
      flexGrow: 1,
      width: '100%',
      padding: '0 0.5em',
    },

    error && { borderColor: RED_G },
  ],
});

export default Input;
